export default __webpack_public_path__ + "static/media/circle-solid.94533103.svg";